/**
 * Funzioni API per la configurazione Admin (E10.11 — RF-7-1 — notification-service).
 * Usano createServiceClient('notification') come da pattern slice 1/2/3.
 */

import { createServiceClient } from '../../api/client.js';
import type { ThresholdSettings, NotificationSeverity } from './types.js';

/** Client parzialmente applicato per il notification-service. */
const notificationApi = createServiceClient('notification');

/**
 * Recupera la soglia di severità corrente per le notifiche.
 * GET /settings/threshold
 */
export function fetchThreshold(): Promise<ThresholdSettings> {
  return notificationApi<ThresholdSettings>('/settings/threshold');
}

/**
 * Aggiorna la soglia di severità globale per le notifiche.
 * PUT /settings/threshold
 */
export function updateThreshold(
  severityThreshold: NotificationSeverity,
): Promise<ThresholdSettings> {
  return notificationApi<ThresholdSettings>('/settings/threshold', {
    method: 'PUT',
    body: { severityThreshold },
  });
}
